import styled from "styled-components";
import { Descriptions } from "antd";
import colors from "css/colors";

const StyledDescriptions = styled(Descriptions)`
  .ant-descriptions-row > th {
    &:empty {
      padding: 0;
    }
  }

  .ant-descriptions-title {
    margin-bottom: 0;
    padding: 13px 20px 10px;
    background-color: ${colors.GREY_LIGHT};
  }

  &.ant-descriptions-bordered {
    .ant-descriptions-row {
      &:nth-child(odd) {
        border: 0;
      }
    }

    .ant-descriptions-view,
    .ant-descriptions-item-content {
      border: 0;
    }
  }
`;

export default StyledDescriptions;
